import type { SVGProps } from "react"

interface Props extends SVGProps<SVGSVGElement> {
	size?: number | string
	title?: string
	strokeWidth?: number | string
}

// IconEnvelopeOutline18 with its color-2 path (the flap) filled to the top edge.
export const EnvelopeDuotoneIcon = ({
	strokeWidth = 1.5,
	size = 18,
	width,
	height,
	title,
	...props
}: Props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width || size}
		height={height || size}
		viewBox="0 0 18 18"
		{...props}
	>
		{title && <title>{title}</title>}
		<rect
			x="1.75"
			y="3.25"
			width="14.5"
			height="11.5"
			rx="2"
			ry="2"
			transform="translate(18 18) rotate(180)"
			fill="none"
			stroke="currentColor"
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M1.75,5.25 L1.75,5.75 l6.767,3.733 c.301,.166,.665,.166,.966,0 L16.25,5.75 L16.25,5.25 A2,2 0 0 0 14.25,3.25 L3.75,3.25 A2,2 0 0 0 1.75,5.25 Z"
			fill="currentColor"
			stroke="currentColor"
			strokeWidth={strokeWidth}
			strokeLinejoin="round"
		/>
	</svg>
)
